import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_9jm6t3tbjk: FaireBrandEntity = {
  token: "b_9jm6t3tbjk",
  type: "brand",
  name: "Ollois",
  avatarUrl:
    "https://cdn.faire.com/fastly/af0cc08df8daefc7fd85d86c75cce1006c5df4845171021b0aac47f54129c657.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/39ad1000d06fdf96fe7a4ea38cad6b0838fad8d04b595c4cc9ee7a8970bfaf7a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/af0cc08df8daefc7fd85d86c75cce1006c5df4845171021b0aac47f54129c657.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/39ad1000d06fdf96fe7a4ea38cad6b0838fad8d04b595c4cc9ee7a8970bfaf7a.jpeg",
  location: "Pacoima, CA, USA",
  minimumOrderDollars: 25,
  rating: 4.9,
  reviewCount: 34,
  isInsider: true,
  description:
    "Homeopathy is growing fast!\nLaunched in 2012, OLLOÏS introduced the first ORGANIC CERTIFIED, LACTOSE-FREE and VEGAN Homeopathic Single Medicines to meet the increasing demand for Organic, dairy-free and Vegan products from the American population. \nIn 2019, we launched OLLOPETS, 12 condition-oriented NATURAL & ORGANIC Homeopathic formulas to support ALL PETS' health and comfort. \nIn 2020, we merged with the Sevene Group in France, to become fully VERTICALLY INTEGRATED, from Seed To Shelf. \nIn 2022, all our remedies became KOSHER CERTIFIED.\nWe are the fastest growing brand of its category (Spins) and distributed in 2000+ retail outlets.\n",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:06.482Z",
    importedBy: "entity-db-cli",
  },
};
